import { forwardRef } from "react";
function SvgRawAssignmentsCompleteIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={19}
        height={22}
        x={4}
        y={4}
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        rx={2}
      />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeWidth={2}
        d="M9 10h9m-9 5h9m-9 5h9"
      />
      <circle
        cx={20}
        cy={20}
        r={8}
        fill="#fff"
        stroke="#1D1D1D"
        strokeWidth={2}
      />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M22 18c-2 2-3 5-3 5l-2-2"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawAssignmentsCompleteIcon);
export default ForwardRef;
